{
  "StatvaluestypeLabel": "Sortie pour les champs pourcentage, date\/heure et durée :",
  "StatvaluestypeBothOptionLabel": "[Double valeurs (formaté + brut)]",
  "StatvaluestypeMainOptionLabel": "Valeur d'affichage formatée uniquement (texte)",
  "StatvaluestypeAlternateOptionLabel": "Valeur brute uniquement (pour l'utilisation de graphiques et de formules)",
  "CSVExportFormat_SectionHeader": "Format d'exportation CSV",
  "CSVExportFormat_SectionPara": "Vous pouvez régler la façon dont les valeurs statistiques en pourcentage, date\/heure et durée sont générées dans les rapports exportés en CSV.",
  "NAME": "CSVExportFormat"
}